export default "__VITE_ASSET__6a6d316d__"